var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/googleplay"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.43 11.9703L16.97 14.5103L19.05 13.3503C20.11 12.7603 20.11 11.2403 19.05 10.6503L16.94 9.47027L14.43 11.9803V11.9703Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.66 11.2103L15.96 8.92027L7.60001 4.23027C7.24001 4.03027 6.86001 3.99027 6.51001 4.06027L13.67 11.2103H13.66Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57001 4.66027C5.38001 4.92027 5.26001 5.24027 5.26001 5.60027V18.4003C5.26001 18.7503 5.37001 19.0503 5.55001 19.3103L12.9 11.9803L5.57001 4.67027V4.66027Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.66 12.7403L6.45001 19.9303C6.81001 20.0203 7.22001 19.9803 7.59001 19.7703L15.98 15.0703L13.65 12.7403H13.66Z",
    fill: "#262626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.6f4354fba68cf18fea8491b80f4c210c.svg";
export { ForwardRef as ReactComponent };